import { openBlock as e, createElementBlock as t, createElementVNode as o } from "vue";
const n = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 48 48"
}, c = /* @__PURE__ */ o("path", { d: "M36.41 4.5h6.616L28.572 21.02 45.576 43.5H32.26L21.832 29.866 9.9 43.5H3.28l15.46-17.67L2.43 4.5h13.65l9.426 12.462L36.406 4.5h.004Zm-2.322 35.04h3.666L14.09 8.252h-3.934L34.088 39.54Z" }, null, -1), r = [
  c
];
function h(s, l) {
  return e(), t("svg", n, r);
}
const _ = { render: h };
export {
  _ as default,
  h as render
};
//# sourceMappingURL=x-twitter.svg.mjs.map
